/**
 * Funcionalitats d'afegir features al mapa (punts, línies poligons) i
 * edició de les seves característiques: estils, coordenades, 
 * dades, capa on pertanyen...
 * */

var drawControl;
var featureActive,crt_Editing,crt_Remove;
var defaultPunt;
var canvas_linia={"id":"cv_linia","strokeStyle":"#FFC500","lineWidth":"3","tipus":"linia","opacity":"100"};
var canvas_pol={"id":"cv_pol","strokeStyle":"#FFC500","opacity":"50","fillStyle":"rgba(255, 197, 0,0.5)","lineWidth":"3","tipus":"pol"};
var canvas_obj_l,cv_ctx_l;
var canvas_obj_p,cv_ctx_p;
var objEdicio={'esticEnEdicio':false,'obroModalFrom':'creaCapa','featureID':null,'esticSobre':false,'edicioPopup':'textFeature'};
//Colores para la edición
var colors_Array_Edicio = ['#ffc500', '#ff7f0b', '#ff4b3a', '#ae59b9', '#00afb5', '#7cbd00', '#90a6a9', '#ebf0f1'];

var drawnItems = new L.FeatureGroup();

function changeRandomDefaults(){
	var randomColorInit=InstamapsUtils.Getters.getRamdomFromArray(colors_Array_Edicio);
	canvas_linia.strokeStyle=randomColorInit;
	canvas_pol.strokeStyle=randomColorInit;
	var randomColorInitRgb = InstamapsUtils.Colors.hexToRgb(randomColorInit);
	randomColorInitRgb.a = 0.5;
	canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(randomColorInitRgb);
	var colorText=getClassFromColor(randomColorInit)	
	default_marker_style.markerColor = colorText,
	default_line_style.color=randomColorInit;
	default_area_style.color=randomColorInit;
	default_area_style.borderColor=randomColorInit;
	default_area_style.fillColor=InstamapsUtils.Colors.getRgbText(randomColorInitRgb);	
	estilP.colorGlif="#000000";
	estilP.iconFons="awesome-marker-web awesome-marker-icon-"+colorText;
	/*
	$("#div_punt").css("color",randomColorInit);
	$("#div_linia").css("color",randomColorInit);
	$("#div_linia").data("lineWidth","3"); 
	$("#div_area").css("color",randomColorInit);
	*/
}

function addRandomStyleInit(){
	jQuery('#div_punt').removeClass();
	jQuery('#div_punt').addClass('awesome-marker-web awesome-marker-icon-'+default_marker_style.markerColor+' fa fa-');
	jQuery('#div_punt').css({"font-size":"14px", "width": "28px", "height": "42px", "color": "rgb(0, 0, 0)", "background-color": "transparent"});	
	//jQuery('#div_punt').css({"font-size":"14px", "width": "28px", "height": "42px", "color": "rgb(0, 0, 0)", "background-color": "transparent", "display":"inline-block", "float":"left"});	
	changeDefaultLineStyle(canvas_linia);
	changeDefaultPointStyle(estilP);
	changeDefaultAreaStyle(canvas_pol);
	/*
	$("#div_punt").css("color",canvas_linia.strokeStyle);
	$("#div_linia").css("color",canvas_linia.strokeStyle);
	$("#div_linia").data("lineWidth",canvas_linia.lineWidth); 
	$("#div_area").css("color",canvas_linia.strokeStyle);
	*/
}

function addDialegEstilsDraw() {
	
	changeRandomDefaults();
	addHtmlInterficieDraw();
	
	jQuery('#div_mes_punts').on("click", function(e) {
		/*
		$('#div_punt').parent().attr("style","background-color:#f2f2f2");
		$('#div_linia').parent().attr("style","background-color:white");
		$('#div_area').parent().attr("style","background-color:white");
		*/
		obrirMenuModal('#dialog_estils_punts','toggle',from_creaCapa);
	});

	jQuery('#div_mes_linies').on("click", function(e) {
		/*
		$('#div_punt').parent().attr("style","background-color:white");
		$('#div_linia').parent().attr("style","background-color:#f2f2f2");
		$('#div_area').parent().attr("style","background-color:white");
		*/
		obrirMenuModal('#dialog_estils_linies','toggle',from_creaCapa);
	});
	
	jQuery('#div_mes_arees').on("click", function(e) {
		/*
		$('#div_punt').parent().attr("style","background-color:white");
		$('#div_linia').parent().attr("style","background-color:white");
		$('#div_area').parent().attr("style","background-color:#f2f2f2");
		*/
		obrirMenuModal('#dialog_estils_arees','toggle',from_creaCapa);
	});
}

/**
 * Funcio que obre el menu dialeg d'estils per punts, linies i poligons
 * */
function obrirMenuModal(_menuClass,estat,_from){
	objEdicio.obroModalFrom=_from;
	//Udate dialog estils a mostrar
	if(_from == from_creaCapa){
		
		if(_menuClass.indexOf("arees")!=-1){
			var defPol = document.getElementById("cv_pol").getContext("2d");
			var fillColor = defPol.fillStyle;
			if(fillColor.indexOf("rgb")!=-1) fillColor = InstamapsUtils.Colors.rgb2hex(defPol.fillStyle);
			var icon = {color: defPol.strokeStyle,
				fillOpacity : InstamapsUtils.Colors.getRgbAlpha(defPol.fillStyle),
				fillColor: fillColor,
				weight: defPol.lineWidth,
				tipus: t_polygon
			};
			updateDialogStyleSelected(icon);
			
		}else if(_menuClass.indexOf("linies")!=-1){
			var defLine = document.getElementById("cv_linia").getContext("2d");
			var icon = {color: defLine.strokeStyle,
				weight: defLine.lineWidth,
				tipus: t_polyline
			};
			updateDialogStyleSelected(icon);			
		
		}else{//es t_marker

			 var styleProps = $("#div_punt").css(["width","height","color","background-color","font-size"]);
			 var punt_class = $("#div_punt").attr("class");
			 var lclass = punt_class.split(" ");
			 //Si es punt inicial per defecte
			 if(punt_class == "dibuix_punt"){
				var icon = {
					icon: "",//glyph
					iconColor: "#000000",
					isCanvas: false,
					className: "awesome-marker",
					markerColor: 'orange',
					tipus: t_marker
				};
				updateDialogStyleSelected(icon);				 
			}else if (punt_class.indexOf("punt_r")!=-1){
			
				//Es punt sense glyphon, CANVAS
				if(!lclass[3] || lclass[3] === "fa-"){
					var icon = {
						icon: "",//glyph
						iconColor: InstamapsUtils.Colors.rgb2hex(styleProps.color),
						fillColor: InstamapsUtils.Colors.rgb2hex(styleProps["background-color"]),
						radius: InstamapsUtils.Styles.getRadiusFromMida(styleProps.width),
						isCanvas: true,
						tipus: t_marker
					};
					updateDialogStyleSelected(icon);
					
				}else{//Es punt amb glyphon
					var iconGlyph = "";
					if(lclass[3]) iconGlyph = lclass[3];
					
					var font = " font"+styleProps["font-size"].substring(0,2);
					var icon = {
						icon: iconGlyph.substring(3) + font,//glyph
						iconColor: InstamapsUtils.Colors.rgb2hex(styleProps.color),
						divColor: InstamapsUtils.Colors.rgb2hex(styleProps["background-color"]),
						isCanvas: false,
						markerColor: punt_class,
						tipus: t_marker
					};
					updateDialogStyleSelected(icon);					 	
				 	}
			 }else{//Pintxo
				var markerColor = (lclass[1].split("-"))[3];
			 	var iconGlyph = "";
			 	if(lclass[3]) iconGlyph = lclass[3];
			 	
				var icon = {
					icon: iconGlyph.substring(3),//glyph
					iconColor: InstamapsUtils.Colors.rgb2hex(styleProps.color),
					isCanvas: false,
					className: "awesome-marker",
					markerColor: markerColor,
					tipus: t_marker
				};
				updateDialogStyleSelected(icon);
			 }
		}
	}	
	
    if (jQuery.isPlainObject( _from )){
    	if (_from.from == tem_clasic){

    	}else{
    		
    		var layers_from = controlCapes._layers[_from.leafletid].layer.getLayers();
        	if( layers_from.length > num_max_pintxos || _from.tipus == t_url_file){
                jQuery('.fila-awesome-markers').hide();
                jQuery('#filaM').hide();
                estilP.iconGlif = "fa fa-";
                activaPuntZ();
        	}else{
        		jQuery('#filaM').show();
                jQuery('.fila-awesome-markers').show(); 
        	}
        	jQuery('.modal').modal('hide');     
            jQuery(_menuClass).modal(estat);
    	}
    }else{
    	jQuery('.fila-awesome-markers').show();
    	jQuery('#filaM').show();
    	jQuery('.modal').modal('hide');     
        jQuery(_menuClass).modal(estat);
    }
    
}

function initCanvas(){
	addGeometryInitP(document.getElementById(canvas_pol.id),"inicial");
	addGeometryInitP(document.getElementById(canvas_pol.id+"0"));
	addGeometryInitL(document.getElementById(canvas_linia.id),"inicial");	
	addGeometryInitL(document.getElementById(canvas_linia.id+"0"));
	
    $('#colorpalette_pf').colorPalette().on('selectColor', function(e) {   	
    	$('.fill_color_pol').css('background-color',e.color);
        $('.fill_color_pol').css('color',e.color);
		canvas_pol.opacity=jQuery('#cmb_trans').val();//Forcem el valor de opacity pq en Chrome no anava bé
		var colorRgb = InstamapsUtils.Colors.hexToRgb(e.color);
		colorRgb.a = (parseInt(jQuery('#cmb_trans').val())/100);		
        canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(colorRgb);
		//console.info("pas1",colorRgb.a,canvas_pol);
    	addGeometryInitP(document.getElementById("cv_pol0"));
    });	
    
    $('#colorpalette_pl').colorPalette().on('selectColor', function(e) {    	
    	var color=InstamapsUtils.Colors.rgb2hex($('.fill_color_pol').css('background-color'));
    	$('.border_color_pol').css('border-color',e.color);
    	canvas_pol.opacity=jQuery('#cmb_trans').val();//Forcem el valor de opacity pq en Chrome no anava bé
		canvas_pol.strokeStyle=e.color;
		var colorRgb = InstamapsUtils.Colors.hexToRgb(color);
		colorRgb.a = (parseInt(jQuery('#cmb_trans').val())/100);
    	canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(colorRgb);
		//console.info("pas2",colorRgb.a,canvas_pol );
    	addGeometryInitP(document.getElementById("cv_pol0"));  
    });
	
	$('#colorpalette_ll').colorPalette().on('selectColor', function(e) {   	
    $('.border_color_linia').css('background-color',e.color);
		canvas_linia.strokeStyle=e.color;
		addGeometryInitL(document.getElementById("cv_linia0"));
	});
 
	$('#colorpalette_icon').colorPalette().on('selectColor', function(e) {  
		$('.fill_color_icon').css('background-color',e.color);
		estilP.colorGlif=e.color;			
		jQuery('.bs-glyphicons li').css('color',estilP.colorGlif);
		if(e.color=="#FFFFFF"){
			jQuery('.bs-glyphicons li').css('background-color','#aaaaaa');	
		}else{
			jQuery('.bs-glyphicons li').css('background-color','#FFFFFF');	
		}
		jQuery('#div_punt0').css('color',estilP.colorGlif);
		jQuery(this).addClass("estil_selected");
	});
	
	$('#colorpalette_punt').colorPalette().on('selectColor', function(e) {  
		$('.fill_color_punt').css('background-color',e.color);			
		if(!jQuery('#div_puntZ').hasClass("estil_selected")){
			activaPuntZ();				
		}else{		 
			estilP.divColor=e.color;				
			jQuery('#div_punt0').css('background-color',estilP.divColor);
		}
		jQuery('#div_punt9').css('background-color',e.color);		
	});
	
	var options = {
		colors:[['#ffc500', '#ff7f0b', '#ff4b3a', '#ae59b9', '#00afb5', '#7cbd00', '#90a6a9', '#ebf0f1']]
	};
	
	$('#colorpalette_marker').colorPalette(options).on('selectColor', function(e) {  
		$('.fill_color_marker').css('background-color',e.color);	
		activaPuntM(e.color);
	});

	jQuery("#cmb_trans").on('change', function(e) { 
    	var color=InstamapsUtils.Colors.rgb2hex($('.fill_color_pol').css('background-color'));
		canvas_pol.opacity=parseInt(jQuery(this).val());
		var colorRgb = InstamapsUtils.Colors.hexToRgb(color);
		colorRgb.a = (parseInt(jQuery('#cmb_trans').val())/100);
    	canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(colorRgb);
		//console.info("pas3",colorRgb.a,canvas_pol);
    	addGeometryInitP(document.getElementById("cv_pol0"));
    });
    
    jQuery("#cmb_gruix").on('change', function(e) { 
    	canvas_pol.lineWidth=jQuery(this).val();
    	var color=InstamapsUtils.Colors.rgb2hex($('.fill_color_pol').css('background-color'));
		canvas_pol.opacity=jQuery('#cmb_trans').val();
		var colorRgb = InstamapsUtils.Colors.hexToRgb(color);
		colorRgb.a = (parseInt(jQuery('#cmb_trans').val())/100);
    	canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(colorRgb);
		//console.info("pas4",colorRgb.a,canvas_pol );
    	addGeometryInitP(document.getElementById("cv_pol0"));
    });
    
    jQuery("#cmb_gruix_l").on('change', function(e) { 
    	canvas_linia.lineWidth=jQuery(this).val();
    	var color=InstamapsUtils.Colors.rgb2hex($('.fill_color_pol').css('background-color'));
		canvas_pol.opacity=jQuery('#cmb_trans').val();
		var colorRgb = InstamapsUtils.Colors.hexToRgb(color);
		colorRgb.a = (parseInt(jQuery('#cmb_trans').val())/100);
    	canvas_pol.fillStyle=InstamapsUtils.Colors.getRgbaText(colorRgb);
		//console.info("pas5",colorRgb.a,canvas_pol );
    	addGeometryInitL(document.getElementById("cv_linia0"));
    });
}

function addGeometryInitL(canvas,inicial){
	if(canvas){
		var	cv_ctx_l=canvas.getContext("2d");
		cv_ctx_l.clearRect(0, 0, canvas.width, canvas.height);
		cv_ctx_l.moveTo(0.7,39.42);
		cv_ctx_l.lineTo(2.05,34.43);
		cv_ctx_l.lineTo(3.62,31.00);
		cv_ctx_l.lineTo(5.95,27.72);
		cv_ctx_l.lineTo(8.17,25.61);
		cv_ctx_l.lineTo(10.72,23.84);
		cv_ctx_l.lineTo(13.059,22.73);
		cv_ctx_l.lineTo(15.32,22.28);
		cv_ctx_l.lineTo(17.76,22.08);
		cv_ctx_l.lineTo(20.30,21.47);
		cv_ctx_l.lineTo(23.28,20.51);
		cv_ctx_l.lineTo(25.88,18.90);
		cv_ctx_l.lineTo(28.265,16.83);
		cv_ctx_l.lineTo(29.9,14.71);
		cv_ctx_l.lineTo(31.89,12.195);
		cv_ctx_l.lineTo(33.62,9.42);
		cv_ctx_l.lineTo(34.81,6.64);
		cv_ctx_l.lineTo(35.46,3.92);
		cv_ctx_l.lineTo(35.52,0.54);
		cv_ctx_l.strokeStyle=canvas_linia.strokeStyle;
		cv_ctx_l.lineWidth=canvas_linia.lineWidth;
		var idLinia = canvas.id;
		if ((inicial==null || inicial==undefined) && idLinia=='cv_linia0'){
			cv_ctx_l.shadowColor = '#999999';
			cv_ctx_l.shadowBlur = 20;
			cv_ctx_l.shadowOffsetX = 15;
			cv_ctx_l.shadowOffsetY = 15;
			cv_ctx_l.stroke(); 	
			cv_ctx_l.shadowOffsetX = -15;
			cv_ctx_l.stroke(); 	
			cv_ctx_l.shadowOffsetY = -15;
			cv_ctx_l.stroke(); 
			cv_ctx_l.shadowOffsetX = 15;
		}
		cv_ctx_l.stroke(); 
	}
}

function addGeometryInitP(canvas,inicial){
	if(canvas){
		var	cv_ctx_p=canvas.getContext("2d");
		cv_ctx_p.clearRect(0, 0, canvas.width, canvas.height);
		cv_ctx_p.moveTo(5.13,15.82);
		cv_ctx_p.lineTo(25.49,5.13);
		cv_ctx_p.lineTo(37.08,13.16);
		cv_ctx_p.lineTo(20.66,38.01);
		cv_ctx_p.lineTo(2.06,33.67);
		cv_ctx_p.closePath();
		cv_ctx_p.strokeStyle=canvas_pol.strokeStyle;
		var fillStyle = "";
		if(canvas_pol.fillStyle.indexOf("rgb")!= -1){
			//console.info("addGeometryInitP1");
			//console.info(canvas_pol);
			fillStyle = canvas_pol.fillStyle;
		} else {

			//console.info("addGeometryInitP2");
			//console.info(canvas_pol);
			var fill = InstamapsUtils.Colors.hexToRgba(canvas_pol.fillStyle,canvas_pol.opacity );
			//console.info("fill",fill);
			fillStyle = InstamapsUtils.Colors.getRgbaText(fill);
			//console.info("fill",fill);
		}
		cv_ctx_p.fillStyle=fillStyle;
		cv_ctx_p.lineWidth=canvas_pol.lineWidth;
		var idPol = canvas.id;
		if ((inicial==null || inicial==undefined) && idPol=='cv_pol0'){
			cv_ctx_p.shadowColor = '#999999';
			cv_ctx_p.shadowBlur = 20;
			cv_ctx_p.shadowOffsetX = 15;
			cv_ctx_p.shadowOffsetY = 18;	
			cv_ctx_p.fill();
			cv_ctx_p.stroke(); 
			cv_ctx_p.shadowOffsetX = -15;
			cv_ctx_p.fill();
			cv_ctx_p.stroke(); 	
			cv_ctx_p.shadowOffsetY = -18;
			cv_ctx_p.fill();
			cv_ctx_p.stroke(); 
			cv_ctx_p.shadowOffsetX = 15;
		}
		cv_ctx_p.fill();
		cv_ctx_p.stroke(); 
	}
}

//Funcio inicialitzar i afegir drawControl
function addDrawToolbar() {
	initCanvas();
	
	var ptbl = L.Icon.extend({
		options : {
			shadowUrl : null,
			iconAnchor : new L.Point(14, 40),
			iconSize : new L.Point(28, 40)
		}
	});

	defaultPunt= L.AwesomeMarkers.icon(default_marker_style);
	map.addLayer(drawnItems);
	
	var options = {
		draw : false,
		polyline : {
			guidelineDistance : 2,
			repeatMode:false,
			shapeOptions : {
				color : '#FFC400',
				weight : 3,
				opacity : 1,
				tipus: t_polyline,
				editing: {
					className: ""
				}
			},
			guideLayers: guideLayers
		},
		polygon : {
			allowIntersection : true, // Restricts shapes
			repeatMode:false,
			guidelineDistance : 2,			
			shapeOptions : {
				color : '#FFC400',
				fillColor: '#FFC400',
				weight : 3,
				fillOpacity : 0.5,
				tipus: t_polygon,
				editing: {
					className: ""
				}
			},
			snapDistance: 10,
			guideLayers: guideLayers
		},
		marker:{repeatMode:false,
			icon:L.icon({iconUrl:'/static/geocatweb/css/images/blank.gif'}),		
			snapDistance: 10,
			snapVertices: false,
			guideLayers: guideLayers
		},
		edit :{
		    featureGroup: drawnItems, //REQUIRED!!
		    remove: false,
		    edit:false
		}
	};
	drawControl = new L.Control.Draw(options);
	map.addControl(drawControl);
		
	addDrawTooltips();
	addRandomStyleInit();
}

function createPopupMapaDraw(geom, event){
	var defer = $.Deferred();
	$.publish('createPopupOnclick', {event: event, element: geom, isDraw: true});
	//TODO ver como hacer para llamar a un callback
	defer.resolve();
	return defer.promise();
}

function activaEdicioUsuari() {
	jQuery('#div_punt').on('click', function() {
		if(featureActive){featureActive.disable();}
		featureActive = new L.Draw.Marker(map, drawControl.options.marker);		 
		featureActive.enable();
	});

	jQuery('#div_linia').on('click', function() {
		if(featureActive){featureActive.disable();}
		drawControl.options.polyline.shapeOptions = InstamapsUtils.Styles.getLineStyleFromToolbar("cv_linia", InstamapsConstants);
		featureActive = new L.Draw.Polyline(map, drawControl.options.polyline);
		featureActive.enable();
	});

	jQuery('#div_area').on('click', function() {
		if(featureActive){featureActive.disable();}
		drawControl.options.polygon.shapeOptions = InstamapsUtils.Styles.getPolygonStyleFromToolbar("cv_pol", InstamapsConstants);
		featureActive = new L.Draw.Polygon(map, drawControl.options.polygon);
		featureActive.enable();
	});

	map.on('draw:drawstart',function(e){
		map.off('click',L.TileLayer.BetterWMS.getFeatureInfo);		
	});

	

	//Afegir features: point, lines and polygons
	map.on('draw:created', function(e) {
		var type = e.layerType, layer = e.layer;
			 
		var html = fillCmbCapesUsr(type);
		if (html===""){
			$('#capaexistentDiv').attr("style","display:none;");
			$('input:radio[name="addlayerRadio"][value="novacapa"]').prop( "checked", true );
		}
		else {
			$('#capaexistentDiv').attr("style","display:block;");
			jQuery('#cmbCapesUsr-newgeometry').html(html);
			$("#cmbCapesUsr-newgeometry option:first").attr('selected','selected');
			$('input:radio[name="addlayerRadio"][value="capaexistent"]').prop( "checked", true );
		}
		
		$('#nomCapaNova')[0].value="";
		jQuery('#dialog_add_layer').show();
		$('#addToLayerBoto').on('click',function(){
			event.preventDefault();
			event.stopImmediatePropagation();		
			var capa = jQuery('#cmbCapesUsr-newgeometry').val();	
			var radio = $('input:radio[name=addlayerRadio]:checked').val(); 			
			var nomCapaNova  = $('#nomCapaNova')[0].value;
			var businessIdCapa="";
			var crearNovaCapa=true;
			if (radio==="novacapa") {
				crearNovaCapa=true;
				
			}
			else if (radio!=="novacapa") {
				crearNovaCapa=false;
				businessIdCapa=capa.replace("#","");
			}					
			createGeometry(type,layer,crearNovaCapa,businessIdCapa,nomCapaNova);
			jQuery('#dialog_add_layer').hide();
			$('#addToLayerBoto').off('click');
		});	
		//Edicio de feature existent
		map.on('click',function(e){
			if ( !e.ctrlKey && e.keyCode == 27) {
				InstamapsUtils.Mapa.openPopupOnClick(e);
			}
		});
		document.body.onkeydown= function(e) {
			if (e.keyCode == 27) InstamapsUtils.Mapa.saveEditedLayer(e); // esc   
		};
	});
}

function createGeometry(type,layer,crearNovaCapa,businessIdCapaOrigen,nomCapaNova){
	var totalFeature;
	var tipusCat,tipusCatDes;
	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'dibuixar geometria', type, 1]});
	drawnItems.addLayer(layer);
	
	if (type === t_marker) {
		tipusCat=window.lang.translate('Títol Punt');
		tipusCatDes=window.lang.translate('Descripció Punt');
		var nomDefecteCapa = window.lang.translate('Capa Punt');
		
		//Mira si és icona
		if(!defaultPunt.options.isCanvas){
			var divIcon = L.divIcon({ 
				html: "<span style='color:blue;'>textToDisplay</span>"
			});
			
			layer=L.marker([layer.getLatLng().lat,layer.getLatLng().lng],
				{icon: defaultPunt,isCanvas:defaultPunt.options.isCanvas,
				 tipus: t_marker}).addTo(map);
		}else{
			//Si és cercle sense glifon
			layer= L.circleMarker([layer.getLatLng().lat,layer.getLatLng().lng],
				{ radius : defaultPunt.options.radius, 
					isCanvas:defaultPunt.options.isCanvas,
					fillColor : defaultPunt.options.fillColor,
					color :  defaultPunt.options.color,
					weight :  defaultPunt.options.weight,
					opacity :  defaultPunt.options.opacity,
					fillOpacity : defaultPunt.options.fillOpacity,
					tipus: t_marker}
			).addTo(map);
		}
		
		if (crearNovaCapa) {
			capaUsrActiva = new L.FeatureGroup();
			var index = parseInt(controlCapes._lastZIndex)+1;
			var nomCapa = "";
			if (nomCapaNova!==undefined && nomCapaNova!==""){
				nomCapa = nomCapaNova;
			}
			else {
				nomCapa=nomDefecteCapa+' '+index;
			}
			capaUsrActiva.options = {
					businessId : '-1',
					nom : nomCapa,
					zIndex :  -1,
					tipus : t_visualitzacio,
					geometryType: t_marker
				};
			map.addLayer(capaUsrActiva);
			capaUsrActiva.on('layeradd',objecteUserAdded);
		}
		else {
			InstamapsUtils.Mapa.findLayerByBusinessId(businessIdCapaOrigen).then(function(layerAct){
				capaUsrActiva = layerAct;
				capaUsrActiva.on('layeradd',objecteUserAdded);
			});
		}

		var auxLat = layer._latlng.lat;
		auxLat= auxLat.toFixed(5);
		var auxLon = layer._latlng.lng;
		auxLon= auxLon.toFixed(5);
		var etrs = InstamapsUtils.Geo.latLngTransformation(layer._latlng.lat, layer._latlng.lng, CRS_ETRS89);
		var auxX = etrs.x;
		var auxY = etrs.y;
		
		var markerLatBound = L.latLngBounds(L.latLng(layer._latlng.lat, layer._latlng.lng), L.latLng(layer._latlng.lat, layer._latlng.lng));
		var sC=map.miraBBContains(markerLatBound);
		if((sC===0)){
			auxX="-";
			auxY="-";
		}
		
		var dataXY =  L.toGeoJSON.getGeojson(auxLon,auxLat);
		var z=0;
		obtenirZByXY(dataXY).then(function(results){
			var coords = results.features[0].geometry.coordinates;
			if (coords.length==3) z = coords[2];
			
			createPointZ(layer, drawnItems, guideLayers, capaUsrActiva, t_marker, tipusCat, tipusCatDes, auxLat, auxLon, auxX, auxY, objecteUserAdded, z);
		},function(){
			createPointZ(layer, drawnItems, guideLayers, capaUsrActiva, t_marker, tipusCat, tipusCatDes, auxLat, auxLon, auxX, auxY, objecteUserAdded, 0);
		});		
	
		
	} else if (type === t_polyline) {
		tipusCat=window.lang.translate('Títol Línia');
		tipusCatDes=window.lang.translate('Descripció Línia');
		var nomDefecteCapa = window.lang.translate('Capa Línia');
		
		if (crearNovaCapa) {
			capaUsrActiva = new L.FeatureGroup();
			var index = parseInt(controlCapes._lastZIndex)+1;
			var nomCapa = "";
			if (nomCapaNova!==undefined && nomCapaNova!==""){
				nomCapa = nomCapaNova;
			}
			else {
				nomCapa=nomDefecteCapa+' '+index;
			}
			capaUsrActiva.options = {
				businessId : '-1',
				nom : nomCapa,
				zIndex :  -1,
				tipus : t_visualitzacio,
				geometryType: t_polyline
			};
			map.addLayer(capaUsrActiva);
			capaUsrActiva.on('layeradd',objecteUserAdded);
		}
		else {
			InstamapsUtils.Mapa.findLayerByBusinessId(businessIdCapaOrigen).then(function(layerAct){
				capaUsrActiva = layerAct;
				capaUsrActiva.on('layeradd',objecteUserAdded);
			});
		}
		
		layer.properties={
			'capaNom':capaUsrActiva.options.nom,//TODO desactualitzat quan es canvii nom capa!
			'capaBusinessId':capaUsrActiva.options.businessId,
			'capaLeafletId': capaUsrActiva._leaflet_id,
			'tipusFeature':t_polyline,
			'mida': InstamapsUtils.Geo.calculateDistance(layer.getLatLngs(), L),
			'longitud (km)': InstamapsUtils.Geo.calculateDistanceWithoutKm(layer.getLatLngs(), L) 
		};	
		
		layer.properties.data={
			'nom':tipusCat+' '+capaUsrActiva.getLayers().length,
			'descripció':tipusCatDes+' '+capaUsrActiva.getLayers().length,
			'longitud (km)': InstamapsUtils.Geo.calculateDistanceWithoutKm(layer.getLatLngs(), L)
		};	
		
		// Add to drawnItems
		drawnItems.addLayer(layer);
		// Add newly drawn feature to list of snappable features
		guideLayers.push(layer);
		capaUsrActiva.removeEventListener('layeradd');
		capaUsrActiva.on('layeradd',objecteUserAdded);
				   
		InstamapsUtils.Dom.createClass('.polyline-style',"font-family:Verdana;font-size:20px;color:red;");
		capaUsrActiva.addLayer(layer);
		
	} else if (type === t_polygon) {
		tipusCat=window.lang.translate('Títol Polígon');
		tipusCatDes=window.lang.translate('Descripció Polígon');	
		var nomDefecteCapa = window.lang.translate('Capa Polígon');
		/*var mida = L.GeometryUtil.geodesicArea(layer.getLatLngs());
		mida = L.GeometryUtil.readableArea(mida,true);*/
		if (crearNovaCapa){
			capaUsrActiva = new L.FeatureGroup();
			var index = parseInt(controlCapes._lastZIndex)+1;
			var nomCapa = "";
			if (nomCapaNova!==undefined && nomCapaNova!==""){
				nomCapa = nomCapaNova;
			}
			else {
				nomCapa=nomDefecteCapa+' '+index;
			}
			capaUsrActiva.options = {
				businessId : '-1',
				nom : nomCapa,
				zIndex :  -1,
				tipus : t_visualitzacio,
				geometryType: t_polygon
			};
			map.addLayer(capaUsrActiva);
			capaUsrActiva.on('layeradd',objecteUserAdded);
		}
		else {
			InstamapsUtils.Mapa.findLayerByBusinessId(businessIdCapaOrigen).then(function(layerAct){
				capaUsrActiva = layerAct;
				capaUsrActiva.on('layeradd',objecteUserAdded);
			});
		}
		layer.properties={
			'capaNom':capaUsrActiva.options.nom,//TODO desactualitzat quan es canvii nom capa!
			'capaBusinessId':capaUsrActiva.options.businessId,
			'capaLeafletId': capaUsrActiva._leaflet_id,
			'tipusFeature':t_polygon,
			'mida': InstamapsUtils.Geo.calculateAreaWithoutHa(layer, L),
			'area (ha)': InstamapsUtils.Geo.calculateAreaWithoutHa(layer, L)
		};
		
		layer.properties.data={
			'nom':tipusCat+' '+capaUsrActiva.getLayers().length,
			'descripció':tipusCatDes+' '+capaUsrActiva.getLayers().length,
			'area (ha)': InstamapsUtils.Geo.calculateAreaWithoutHa(layer, L)
		};		
		
		// Add to drawnItems
		drawnItems.addLayer(layer);
		// Add newly drawn feature to list of snappable features
		guideLayers.push(layer);
		capaUsrActiva.removeEventListener('layeradd');
		capaUsrActiva.on('layeradd',objecteUserAdded);
		capaUsrActiva.addLayer(layer);
	}
}

function createPointZ(layer, drawnItems, guideLayers, capaUsrActiva, t_marker, tipusCat, tipusCatDes, auxLat, auxLon, auxX, auxY, objecteUserAdded, z){
	layer.properties={
		'capaNom':capaUsrActiva.options.nom,//TODO desactualitzat quan es canvii nom capa!
		'capaBusinessId':capaUsrActiva.options.businessId,
		'capaLeafletId': capaUsrActiva._leaflet_id,
		'tipusFeature':t_marker,
		'cota':z};	

	layer.properties.data={
		'nom':tipusCat+' '+capaUsrActiva.getLayers().length,
		'descripció':tipusCatDes+' '+capaUsrActiva.getLayers().length,
		'latitud':auxLat,
		'longitud':auxLon,
		//'etrs89_x':auxX,
		//'etrs89_y':auxY,
		'cota':z
	};
	// Add to drawnItems
	drawnItems.addLayer(layer);
	// Add newly drawn feature to list of snappable features
	guideLayers.push(layer);
	capaUsrActiva.removeEventListener('layeradd');
	capaUsrActiva.on('layeradd',objecteUserAdded);
	capaUsrActiva.addLayer(layer);
}

//Funcio que crea Pop up de la feature quan te opcio d'edicio
function createPopupWindow(layer,type, editant,propFormat, propPrivacitat,capaEdicio){
	var esVisor = (-1 != $(location).attr('href').indexOf('instavisor')) || (-1 != $(location).attr('href').indexOf('visor'));
	var data={
		type: type,
		editable: editant,
		origen: true,
		capa: capaEdicio,
		esVisor: esVisor
	};
	var html = PopupManager().createPopupHtml(layer, data);//player es feature

	return html;
}

function reFillCmbCapesUsr(type, businessIdCapa){
	var html = "";
	var layers=undefined;
	if (undefined != controlCapes._layers) layers = controlCapes._layers;
	if ((layers===undefined || (layers!==undefined && jQuery.isEmptyObject(layers))) && undefined != controlCapes._visLayers) layers = controlCapes._visLayers;
	$.each( layers, function(i,val) {
		var layer = val.layer.options;
		var nom=layer.nom;
		if (layer.dinamic==undefined || (layer.dinamic!=undefined && !layer.dinamic)) {
			if(layer.tipus==t_tematic && layer.geometryType==type ){
		        html += "<option value=\"";
		        html += layer.businessId +"#"+val.layer._leaflet_id+"\"";
		        if(businessIdCapa == layer.businessId) html += " selected";
		        html += ">"+ nom.substring(0,20) + "</option>";            		
			}else if(layer.tipus==t_visualitzacio && layer.geometryType==type ){
		        html += "<option value=\"";
		        html += layer.businessId +"#"+val.layer._leaflet_id+"\"";
		        if(businessIdCapa == layer.businessId) html += " selected";
		        html += ">"+ nom.substring(0,20) + "</option>";            		
			}
		}
	});		
	return html;
}

function objecteUserAdded(f,capaMare,crearNovaCapaEd){
	InstamapsUtils.Mapa.closePopup(jQuery, map);	

	//console.info("objecteUserAdded");
	//console.info(f,capaMare,crearNovaCapaEd);
	var fId;
	try{
		fId = this.toGeoJSON().features.length;
	}catch(e){
		fId = capaMare.toGeoJSON().features.length;
	}
	
	var feature;
	try{
		 feature = f.layer.toGeoJSON();
	}catch(e){
		 feature= f.toGeoJSON();
	}
	
	var crearNovaCapa=false;

	var layerF;

	if (f.layer !==  undefined) {
		layerF = f.layer;
	}
	else {
		layerF = f;
	}
	
	if(capaUsrActiva != null && capaUsrActiva.options.geometryType != layerF.options.tipus){
		crearNovaCapa=true;
	}
	else if (capaUsrActiva !=null && capaUsrActiva.options.businessId==-1){
		crearNovaCapa=true;
	}
	else if(capaUsrActiva == null){
		crearNovaCapa=true;
	}

	if (crearNovaCapaEd!==undefined){
		crearNovaCapa = crearNovaCapaEd;
		capaUsrActiva = capaMare;
	}

	feature.properties.data = layerF.properties.data;    	

	var features = JSON.stringify(feature);

	var layerF;
	if (f.layer !==  undefined) {
		layerF = f.layer;
	}
	else {
		layerF = f;
	}
	var rangsJSON = getFeatureStyle(layerF.options, layerF.options.tipus);
	var rangs = JSON.stringify(rangsJSON);

	
	if (crearNovaCapa) {
		var _this = this;
		var opts = "nom,descripció,";
		if  (layerF.options.tipus==t_marker){
			opts += "latitud,longitud,cota";
		}
		else if (layerF.options.tipus==t_polyline){
			opts += "longitud (km)";
		}
		else if (layerF.options.tipus==t_polygon){
			opts += "area (ha)";
		}
		var optionsStr =  "{\"propName\":\""+opts+"\"}";
		/*NOU MODEL: Crear nova visualització*/
		var data ={
			uid: Cookies.get('uid'),
			nom: layerF.properties.capaNom,
			mapBusinessId: url('?businessid'),
			geometryType: layerF.options.tipus,
			activas: true,
			visibilitats: true,				
			publica : true,
			options: optionsStr
		};		
		
		createVisualitzacioLayer(data).then(function(results) {
			
			if(results.status === 'OK'){
				
				_this.options.businessId = results.results.businessId;
				layerF.properties.capaBusinessId = results.results.businessId;
				//Ara afegim nova geometria
				var features = {
					type:layerF.options.tipus,
					id:fId,
					properties: feature.properties.data,
					estil: rangsJSON,
					geometry: feature.geometry
				};
				
				features = JSON.stringify(features);				
				
				data = {
					businessId: layerF.properties.capaBusinessId,//Bid de la visualitzacio
					uid: Cookies.get('uid'),
					features: features,
					geometryType: layerF.options.tipus,
					options: opts
				};
				var businessIdCapaOrigen = data.businessId;
				//actualizar servidorswms del mapconfig
				var servidor = '';
				if (results.results !== undefined) servidor = results.results;
				else if (results.options !== undefined) servidor = results.options;
				mapConfig.servidorsWMS = InstamapsUtils.Mapa.actualitzarServidorsWMS(null,"alta",servidor,null,mapConfig.servidorsWMS);
				
				addGeometriaToVisualitzacio(data).then(function(results) {
					if(results.status === 'OK'){
						layerF.properties.businessId = results.feature.businessId;
						layerF.properties.estil = results.results.estil[0];
						layerF.properties.feature = results.feature;	
						finishAddFeatureToTematic(layerF).then(function(layer){
							openPopupDraw(layer);
							controlCapes.forceUpdate(true);
						});			
						
					}else{
						console.debug('addGeometriaToVisualitzacio ERROR');
					}
				},function(results){
					console.debug('addGeometriaToVisualitzacio ERROR');
				});
				
			}else{//ERROR: control Error
				console.debug('createVisualitzacioLayer ERROR');
			}
		},function(results){//ERROR: control Error
			console.debug('createVisualitzacioLayer ERROR');
		});			

	} else  {
	
		var businessIdCapa="";
		var leafletIdCapa=capaUsrActiva._leaflet_id;
		if (capaUsrActiva!=null && businessIdCapa==""){
			businessIdCapa=capaUsrActiva.options.businessId;
		}
		else if (businessIdCapa==""){
			businessIdCapa = this.options.businessId;
		} 
		layerF.properties.capaBusinessId=businessIdCapa;
		var features = {
			type:layerF.options.tipus,
			id:fId,
			properties: feature.properties.data,
			estil: rangsJSON,
			geometry: feature.geometry
		};
		features = JSON.stringify(features);				
		
		data = {
			businessId: businessIdCapa,//layerF.properties.capaBusinessId,//Bid de la visualitzacio
			uid: Cookies.get('uid'),
			features: features
		};		
		var businessIdCapaOrigen = data.businessId;
		
		addGeometriaToVisualitzacio(data).then(function(results) {
			if(results.status === 'OK'){
				layerF.properties.businessId = results.feature.businessId;
				layerF.properties.estil = results.results.estil[0];
				layerF.properties.feature = results.feature;
				var layerServidor=results.servidor;
				InstamapsUtils.Mapa.findLayerByBusinessId(businessIdCapaOrigen).then(function(layerAct){
					capaUsrActiva = layerAct;
					finishAddFeatureToTematic(layerF).then(function(layer){						
						//updateFeatureCount(null, capaUsrActiva.options.businessId);
						openPopupDraw(layer);
						controlCapes.forceUpdate(true);
					});
			
				});
	 
			}else{
				console.debug('addGeometriaToVisualitzacio ERROR');
			}
		},function(results){
			console.debug('addGeometriaToVisualitzacio ERROR');
		});			
	}
	
}

function getFeatureStyle(estil, tipus, businessId){
	var rangs = {};
	//ESTIL MARKER
	if( tipus == t_marker){
		if (estil.icon!= undefined){
			rangs = {
				color : estil.icon.options.fillColor,//Color principal
				marker:estil.icon.options.markerColor,//Si es de tipus punt_r o el color del marker
				simbolColor:estil.icon.options.iconColor,//Glyphon
				radius :estil.icon.options.radius,//Radius
				iconSize :estil.icon.options.iconSize.x+"#"+estil.icon.options.iconSize.y,//Size del cercle
				iconAnchor :estil.icon.options.iconAnchor.x+"#"+estil.icon.options.iconAnchor.y,//Anchor del cercle
				simbol : jQuery.trim(estil.icon.options.icon),//tipus glyph
				simbolSize : estil.icon.options.simbolSize,//mida glyphon
				opacity : (estil.opacity * 100),
				label : false,
				labelSize : 10,
				labelFont : 'arial',
				labelColor : '#000000'
			};
		}else{
			rangs = {
				color : estil.fillColor,
				simbolSize : estil.radius,
				opacity : (estil.fillOpacity * 100),
				label : false,
				labelSize : 10,
				labelFont : 'arial',
				labelColor : '#000000',
				borderWidth : estil.weight,
				borderColor : estil.color
			};
		}
	//ESTIL LINE
	}else if(tipus == t_polyline){
		rangs = {
			color : estil.color,
			lineWidth : estil.weight,
			lineStyle : 'solid',
			borderWidth : 2,
			borderColor : estil.color,
			opacity : (estil.opacity * 100),
			label : false,
			labelSize : 10,
			labelFont : 'arial',
			labelColor : '#000000'
		};	
	//ESTIL POLIGON		
	}else{
		var fillColor = estil.fillColor;
		if(estil.fillColor  && fillColor.indexOf("#")==-1) fillColor = InstamapsUtils.Colors.rgb2hex(estil.fillColor);
		var fillOpacity = estil.fillOpacity;
		if (isNaN(fillOpacity)){ fillOpacity = 1;}
		rangs = {
			color : fillColor,
			fillColor: fillColor,
			fillOpacity: fillOpacity,
			lineWidth : estil.dashArray,
			lineStyle : 'solid',
			borderWidth : estil.dashArray,
			borderColor : estil.color,
			opacity : (fillOpacity * 100),
			label : false,
			labelSize : 10,
			labelFont : 'arial',
			labelColor : '#000000'
		};				
	}
	if(businessId){
		rangs.businessId = businessId;
	}
	return rangs;
}

function finishAddFeatureToTematic(layer){
	var defer = $.Deferred();
	var type = layer.options.tipus;
	//Afegir capa edicio a control de capes en cas que sigui nova
	if (capaUsrActiva.toGeoJSON().features.length == 1 ) {
		//Actualitzem zIndex abans d'afegir al control de capes
		if(controlCapes) {
			capaUsrActiva.options.estil = layer.options.estil;
			capaUsrActiva.options.zIndex = controlCapes._lastZIndex+1; 								
			controlCapes.addOverlay(capaUsrActiva,	capaUsrActiva.options.nom, true);
			controlCapes._lastZIndex++;
		}
		InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
		if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
			updateSortablesElements();
		}
	}else{
		//Actualitzem comptador de la capa
		updateFeatureCount(null, capaUsrActiva.options.businessId);
	}
		
	var esVisor = (-1 != $(location).attr('href').indexOf('instavisor')) || (-1 != $(location).attr('href').indexOf('visor'));
	var data={
		type: type,
		editable: true,
		origen: true,
		capa: capaUsrActiva,
		esVisor: esVisor
	};
	//var html = createPopupWindow(layer,type, true);
	var html = PopupManager().createPopupHtml(layer, data);//layer es feature
	layer.properties.feature.properties.popupData = html;
	layer.properties.feature.properties.capaNom = capaUsrActiva.options.nom;
	layer.properties.popupData = html;
	layer.properties.capaNom = capaUsrActiva.options.nom;
	layer.properties.capaLeafletId = capaUsrActiva._leaflet_id;
	layer.on('click', creaPopupUnic); //Afegim event on click
	InstamapsUtils.Mapa.closePopup(jQuery, map);	
	
	defer.resolve(layer);
	return defer.promise();

}

function openPopupDraw(layer){
	var defer = $.Deferred();
	if (layer.properties.tipusFeature=="polyline"){
		createPopupMapaDraw(layer, {latlng: layer._latlngs[0]}).then(function() {
			actualitzarComboCapes();	
			defer.resolve();
		});
	}
	else if (layer.properties.tipusFeature=="polygon"){
		createPopupMapaDraw(layer, {latlng: layer.getBounds().getCenter()}).then(function() {
			actualitzarComboCapes();
			defer.resolve();	
		});
	}
	else {
		createPopupMapaDraw(layer, {latlng: layer._latlng}).then(function() {
			actualitzarComboCapes();				
			defer.resolve();
		});
	}
	return defer.promise();
}

function updateFeatureNameDescr(layer, titol, descr){
	
	layer.properties.data.nom=titol;
	layer.properties.data.text=descr;
	
	var features = {
		type: layer.properties.tipusFeature,
		id:3124,
		businessId: layer.properties.businessId,//Bid de la geometria q estas afegint
		properties: layer.properties.data,
		estil: layer.properties.estil,
		geometry: layer.properties.feature.geometry
	};
	
	features = JSON.stringify(features);
	
    var data = {
		uid : Cookies.get('uid'),
		features : features,
		businessId: layer.properties.businessId
	};      	
	
    updateGeometria(data).then(function(results){
	    if(results.status == 'OK'){
			//recarrego les sublayers de la capa modificada
	    	var capaEdicio = controlCapes._layers[layer.properties.capaLeafletId];
			var html = createPopupWindow(layer, "marker", true, null,null,capaEdicio);
			layer.properties.feature.properties.popupData = html;
			layer.properties.popupData = html;
			
			actualitzacioTematic(capaEdicio,layer.properties.capaBusinessId,"3124",null,features,"modificacioInfo");
			
			jQuery('#titol_pres').text(titol).append(' <i class="glyphicon glyphicon-pencil gris-semifosc"></i>');
			var txt = descr;			
			if (!$.isNumeric(txt) && !InstamapsUtils.Validator.isWKT(txt)) {
				txt = InstamapsUtils.Getters.parseUrlTextPopUp(txt,"");
				if(typeof(txt) === "string" && txt.indexOf("iframe")==-1 && txt.indexOf("img")==-1){
					jQuery('#des_pres').html('');
					jQuery('#des_pres').append('<span id="descrText" style="display:none;">'+descr+'</span>');
					jQuery('#des_pres').append(txt).append(' <i class="glyphicon glyphicon-pencil gris-semifosc"></i>');
				}else{
					jQuery('#des_pres').html('');
					jQuery('#des_pres').append('<span id="descrText" style="display:none;">'+descr+'</span>');
					jQuery('#des_pres').append(txt).append(' <i class="glyphicon glyphicon-pencil gris-semifosc"></i>');
				}
			}
			else {
				jQuery('#des_pres').html('');
				jQuery('#des_pres').append('<span id="descrText" style="display:none;">'+descr+'</span>');
				jQuery('#des_pres').text(txt).append(' <i class="glyphicon glyphicon-pencil gris-semifosc"></i>');
			}
			
			jQuery('.popup_pres').show();
			jQuery('.popup_edit').hide();   
						
		}else{
	        console.debug("updateGeometria ERROR");
	    }
	}, function(results){
		  console.debug("updateGeometria ERROR");
	}); 		
        
}

function updateFeatureMove(featureID, capaEdicioID, capaEdicioLeafletId){
	var defer = $.Deferred();
    var layer = map._layers[featureID];
    
    var feature = layer.toGeoJSON();
    
    feature.geometry = layer.properties.feature.geometry;      
        
    if(layer.properties.tipusFeature == t_marker){
        var newLatLng = layer.getLatLng();
        feature.geometry.coordinates[1] = newLatLng.lat;
		feature.geometry.coordinates[0] = newLatLng.lng;   
		var auxLat = newLatLng.lat;
		auxLat= auxLat.toFixed(5);
		var auxLon = newLatLng.lng;
		auxLon= auxLon.toFixed(5);
		if (layer.properties.data["latitud"]!==undefined){
			layer.properties.data["latitud"] = auxLat;
		}
		if (layer.properties.data["longitud"]!==undefined){
			layer.properties.data["longitud"] = auxLon;
		}
		
    }else{
	    var lcoordinates = [];
	                
	    if(layer.properties.tipusFeature == t_polyline){
			$.each(layer._latlngs, function(i,val) {
				lcoordinates.push([val.lng, val.lat]);
			}); 
			var longitudL = InstamapsUtils.Geo.calculateDistanceWithoutKm(layer.getLatLngs(), L);
			feature.geometry.coordinates = lcoordinates;
			layer.properties.mida = longitudL;
			if (layer.properties.data["longitud (km)"]!==undefined){
				layer.properties.data["longitud (km)"]=longitudL;
			}
			/*layer.properties.data={
				'nom':layer.properties.data.nom,
				'descripcio':layer.properties.data.text,
				'longitud (km)': longitudL
			};*/
	    }else{
			$.each(layer._latlngs, function(i,val) {
				$.each(val,function(j,val2){
					lcoordinates.push([val2.lng, val2.lat]);
				});				
			}); 
			var area = InstamapsUtils.Geo.calculateAreaWithoutHa(layer, L);
	    	lcoordinates.push(lcoordinates[0]);
	    	feature.geometry.coordinates[0] = lcoordinates;
			layer.properties.mida = area;
			if (layer.properties.data["area (ha)"]!==undefined){
				layer.properties.data["area (ha)"]=area;
			}		
			/*layer.properties.data={
				'nom':layer.properties.data.nom,
				'descripcio':layer.properties.data.text,
				'area (ha)': area
			};*/
	    }
    }
	
	var estilL=layer.properties.estil;
	if (estilL.opacity){
		if (estilL.opacity===0.25) estilL.opacity = 25;
		else if (estilL.opacity===0.5) estilL.opacity = 50;
		else if (estilL.opacity===0.75) estilL.opacity = 75;
		else if (estilL.opacity==0.9) estilL.opacity = 90;
		else {
			var opac = estilL.opacity;
			try{
				if (opac.match(new RegExp("^[0-9]*[.][0-9]+$"))!==null){
					estilL.opacity= opac*100;
				}	
			}catch(e){

			}		
		}
	}



	var features = {
		type: layer.properties.tipusFeature,
		id:3124,
		businessId: layer.properties.businessId,//Bid de la geometria q estas afegint
		properties: layer.properties.data,
		estil: estilL,
		geometry: feature.geometry
	};
	features = JSON.stringify(features);
	
    var data = {
		uid : Cookies.get('uid'),
		features : features,
		businessId: layer.properties.businessId
	};      	
	
    updateGeometria(data).then(function(results){
		if(results.status == 'OK'){
	    	//Actualitzem visualitzacions de la capa on estava la geometria modificada
	    	var capaEdicio = controlCapes._layers[capaEdicioLeafletId];
	    	var html = createPopupWindow(layer,layer.properties.tipusFeature, true,null,null,capaEdicio);
			layer.properties.feature.properties.popupData = html;
			layer.properties.popupData = html;
			
	    	//jQuery('.popup_pres').show();
	    	
	    	//recarrego les sublayers de la capa modificada	
	    	actualitzacioTematic(capaEdicio,layer.properties.capaBusinessId,null,null,null,"baixa");
			defer.resolve();
		}else{
	        console.debug("updateFeature ERROR");
	    }
	}, function(results){
		  console.debug("updateFeature ERROR");
	});      	
  
    //Retornem la geometria a la seva capa original
    capaUsrActiva.addLayer(layer);
    capaUsrActiva.on('layeradd',objecteUserAdded);//Deixem activat event layeradd, per la capa activa
    if(layer.properties.tipusFeature !== t_marker) map._layers[capaEdicioID].removeLayer(layer);
    //Refresh de la capa
    controlCapes._map.removeLayer(capaUsrActiva);
	controlCapes._map.addLayer(capaUsrActiva);
	if(layer.properties.tipusFeature !== t_marker) map.removeLayer(map._layers[capaEdicioID]);
    
    //Fi edicio
	objEdicio.esticEnEdicio=false;
	return defer.promise();
}

function fillCmbCapesUsr(type,_leaflet_id){
	var html = "";
	var layers=undefined;
	if (_leaflet_id===undefined) _leaflet_id="";
	if(controlCapes) {
		
		if (undefined != controlCapes._layers) layers = controlCapes._layers;
		if ((layers===undefined || (layers!==undefined && jQuery.isEmptyObject(layers))) && undefined != controlCapes._visLayers) layers = controlCapes._visLayers;
		$.each( layers, function(i,val) {
			var layer = val;
			if (undefined != val.layer) layer = val.layer.options;
				
			var isVisualitzacio = (layer.tipus==t_visualitzacio || layer.tipus==tem_origen || layer.tipus==tem_simple || layer.tipus==tem_clasic ||
				layer.tipus==tem_heatmap || layer.tipus==tem_cluster);
				
			if(layer.tipus==t_tematic && layer.geometryType==type ){
				html += "<option value=\"";
				html += layer.businessId +"#"+_leaflet_id+"\"";
				if(capaUsrActiva && (capaUsrActiva.options.businessId == layer.businessId)) html += " selected";
				html += ">"+ layer.nom + "</option>";
			//nou model    
			}else if(isVisualitzacio && layer.geometryType==type /*&& !layer.source*/){
				html += "<option value=\"";
				html += layer.businessId +"#"+_leaflet_id+"\"";
				if(capaUsrActiva && (capaUsrActiva.options.businessId == layer.businessId)) html += " selected";
				html += ">"+ layer.nom + "</option>";
			}
		});		

	}
	
	return html;
}

function generaNovaCapaUsuari(feature,nomNovaCapa){
	var propName="";
	if (feature.properties.data!=undefined && ("string" !== typeof feature.properties.data)) properties=feature.properties.data;
	else if (feature.properties!=undefined) properties=feature.properties;
	if ("" === propName) propName = Object.keys(properties).join();
	
	/*NOU MODEL: Crear nova visualització*/
	var data ={
		uid: Cookies.get('uid'),
		nom: nomNovaCapa,
		mapBusinessId: url('?businessid'),
		geometryType: feature.properties.tipusFeature,
		activas: true,
		visibilitats: true,				
		publica : true,
		options: propName			
	};		
	
	createVisualitzacioLayer(data).then(function(results){
		if(results.status === 'OK'){
			
			capaUsrActiva2= new L.FeatureGroup();
			capaUsrActiva2.options = {
				businessId : results.results.businessId,
				nom : nomNovaCapa,
				tipus: t_visualitzacio,
				geometryType : feature.properties.tipusFeature
			};
			
			map.addLayer(capaUsrActiva2);
			capaUsrActiva2.options.zIndex = controlCapes._lastZIndex+1;
			controlCapes.addOverlay(capaUsrActiva2,	capaUsrActiva2.options.nom, true);
			controlCapes._lastZIndex++;
			
			var estilL=feature.properties.estil;
			if (estilL.opacity){
				if (estilL.opacity===0.25) estilL.opacity = 25;
				else if (estilL.opacity===0.5) estilL.opacity = 50;
				else if (estilL.opacity===0.75) estilL.opacity = 75;
			}

			var features = {
				type: feature.properties.tipusFeature,
				id:3124,
				businessId: feature.properties.businessId,//Bid de la geometria q estas afegint
				properties: feature.properties.data,
				estil: estilL,
				geometry: feature.properties.feature.geometry
			};
			
			features = JSON.stringify(features);
			
			var data= {
				toBusinessId: results.results.businessId,//'4c216bc1cdd8b3a69440b45b2713b000',//bID de la visualitzacio-capa
				fromBusinessId: feature.properties.capaBusinessId,//'4c216bc1cdd8b3a69440b45b2713b001',//bID de la visualitzacio-capa
				uid: Cookies.get('uid'),
				features: features
			}	
			
			moveGeometriaToVisualitzacio(data).then(function(resultsMove) {
				if(resultsMove.status === 'OK'){
					capaUsrActiva=capaUsrActiva2;
					InstamapsUtils.Mapa.findLayerByBusinessId(data.fromBusinessId).then(function(layerAct){
						reloadSingleLayer(controlCapes._layers[layerAct._leaflet_id], resultsMove.layerFrom).then(function(){
							InstamapsUtils.Mapa.findLayerByBusinessId(data.toBusinessId).then(function(layerAct2){							
								reloadSingleLayer(controlCapes._layers[layerAct2._leaflet_id], resultsMove.layerTo).then(function(){
									InstamapsUtils.Mapa.closePopup(jQuery, map);
								});
							});
						});
					});
				}else{
					console.debug("moveGeometriaToVisualitzacio ERROR");
				}
			},function(results){
				console.debug("moveGeometriaToVisualitzacio ERROR");
			});
			
		}else{
			console.debug("createVisualitzacioLayer ERROR");
		}
	});		

}

function moveFeatureToLayer(feature_businessId,layer_fromBusinessId,layer_toBusinessId){
	var estilL=feature.properties.estil;
	if (estilL.opacity){
		if (estilL.opacity===0.25) estilL.opacity = 25;
		else if (estilL.opacity===0.5) estilL.opacity = 50;
		else if (estilL.opacity===0.75) estilL.opacity = 75;
	}
	/*NOU MODEL*/
	var features = {
		type: feature.options.tipus,
		id:3124,
		businessId: feature.properties.businessId,//Bid de la geometria q estas afegint
		properties: feature.properties.feature.properties,
		estil: estilL,
		geometry: feature.properties.feature.geometry
	};
	
	features = JSON.stringify(features);
	
	var data= {
		toBusinessId: results.results.businessId,//'4c216bc1cdd8b3a69440b45b2713b000',//bID de la visualitzacio-capa
		fromBusinessId: feature.properties.capaBusinessId,//'4c216bc1cdd8b3a69440b45b2713b001',//bID de la visualitzacio-capa
		uid: Cookies.get('uid'),
		features: features
	}	
	
	moveGeometriaToVisualitzacio(data).then(function(resultsMove) {
		//console.debug("moveGeometriaToVisualitzacio:"+ resultsMove.status);
		if(resultsMove.status === 'OK'){
			
			if(capaUsrActiva) capaUsrActiva.removeLayer(feature);
			capaUsrActiva2.addLayer(feature);//.on('layeradd', objecteUserAdded);
			//Actualitzem capa activa
			if(capaUsrActiva) capaUsrActiva.removeEventListener('layeradd');
			capaUsrActiva = capaUsrActiva2;//map._layers[capaUsrActiva2._leaflet_id];;
			capaUsrActiva.on('layeradd',objecteUserAdded);	
			//Actualitzem properties de la layer
			feature.properties.capaBusinessId = capaUsrActiva.options.businessId;
			feature.properties.capaNom = capaUsrActiva.options.nom;	
			feature.properties.capaLeafletId = capaUsrActiva._leaflet_id;
			//Actualitzem popup del marker
			InstamapsUtils.Mapa.closePopup(jQuery, map);
			if (layer.properties.tipusFeature=="polygon" || layer.properties.tipusFeature=="polyline"){
				createPopupMapaDraw(feature, {latlng: feature._latlngs[0]}).then(function() {
					actualitzarComboCapes();				
				});
			}
			else {
				createPopupMapaDraw(feature, {latlng: feature._latlng}).then(function() {
					actualitzarComboCapes();				
				});
			}
			
			var capaEdicio = controlCapes._layers[capaUsrActiva._leaflet_id];
			//recarrego les sublayers de la capa modificada	
			actualitzacioTematic(capaEdicio,layer.properties.capaBusinessId,"3124",feature,features,"modificacio");
			
			//Actualitzem comptador de la capa
		    updateFeatureCount(data.fromBusinessId, data.toBusinessId);					
			InstamapsUtils.Mapa.closePopup(jQuery, map);
		}else{
			console.debug("moveGeometriaToVisualitzacio ERROR");
		}
	},function(results){
		console.debug("moveGeometriaToVisualitzacio ERROR");
	});		

}

function modeLayerTextEdit(){
	jQuery('#capa_txt').show();
	jQuery('#feature_txt').hide();
	jQuery('.bs-ncapa').hide();
	jQuery('.popup_edit').show();	
}

function modeEditText(){
	objEdicio.edicioPopup='textFeature';
	jQuery('#capa_txt').hide();
	jQuery('#feature_txt').show();
	var txtTitol=jQuery('#titol_pres').text();
	var txtDesc=jQuery('#descrText').html();
	jQuery('#titol_edit').val(txtTitol);	
	jQuery('#des_edit').text(txtDesc);
	jQuery('.popup_pres').hide();
	jQuery('.popup_edit').show();	
}

/*funcio que actualitza l'estil seleccionat al dialeg d'estils, 
 * amb el de la feature que es col editar 
 * */
function updateDialogStyleSelected(icon){
  
	if(icon.tipus == t_polyline){
		
		canvas_linia.lineWidth = icon.weight;
		canvas_linia.strokeStyle = icon.color;
		
		$("#cmb_gruix_l option[value='"+icon.weight+"']").prop("selected", "selected");
		$('.border_color_linia').css('background-color',icon.color);
		addGeometryInitL(document.getElementById("cv_linia0"));			
		
	}else if(icon.tipus == t_polygon){
		
		canvas_pol.strokeStyle = icon.color;
		canvas_pol.opacity = icon.fillOpacity;
		canvas_pol.fillStyle = icon.fillColor;
		canvas_pol.lineWidth = icon.weight;
		
		$('.border_color_pol').css('border-color',icon.color);
		$('.fill_color_pol').css('color',icon.fillColor);
		$('.fill_color_pol').css('background-color',icon.fillColor);
		$("#cmb_gruix option[value='"+icon.weight+"']").prop("selected", "selected");
		$("#cmb_trans option[value='"+icon.fillOpacity+"']").prop("selected", "selected");
		
	    addGeometryInitP(document.getElementById("cv_pol0"));
	    
	}else{//es t_marker
		
		//Deselecciono estil al modal 
		jQuery("#div_puntM").removeClass("estil_selected");
		jQuery("#div_puntZ").removeClass("estil_selected");
		jQuery(".bs-glyphicons li").removeClass("estil_selected");		
			
		if(icon.isCanvas){//Si es un punt
			
			var midaPunt = InstamapsUtils.Styles.getMidaFromRadius(icon.radius);
			
			estilP.iconFons = 'awesome-marker-web awesome-marker-icon-punt_r';
			estilP.iconGlif = 'fa fa-'+icon.icon;
			estilP.colorGlif = icon.iconColor;
			estilP.divColor = icon.fillColor;
			estilP.width = midaPunt+'px';
			estilP.height = midaPunt+'px';

			jQuery("#div_puntZ").addClass("estil_selected");
			jQuery("#div_punt9").css("background-color",icon.fillColor);
			$('#cmb_mida_Punt option[value="'+midaPunt+'"]').prop("selected", "selected");
			jQuery("#dv_fill_color_punt").css("background-color",icon.fillColor);
			jQuery("#dv_fill_color_icon").css("background-color",icon.iconColor);

		}else if(icon.markerColor.indexOf("punt_r")!=-1){
			
			var licon = icon.icon.split(" ");
			midaPunt = InstamapsUtils.Styles.getMidaFromFont(licon[1]);
			
			estilP.iconFons = 'awesome-marker-web awesome-marker-icon-punt_r';
			estilP.iconGlif = 'fa fa-'+icon.icon;
			estilP.colorGlif =icon.iconColor;
			estilP.fontsize = licon[1];	
			estilP.width = midaPunt+'px';
			estilP.height = midaPunt+'px';
			estilP.divColor = icon.divColor;
		
			jQuery("#div_puntZ").addClass("estil_selected");
			jQuery("#div_punt9").css("background-color",icon.divColor);
			$('#cmb_mida_Punt option[value="'+midaPunt+'"]').prop("selected", "selected");
			
			jQuery("#dv_fill_color_punt").css("background-color",icon.divColor);
			jQuery("#dv_fill_color_icon").css("background-color",icon.iconColor);				
			
			jQuery(".bs-glyphicons li .fa-"+licon[0]).parent('li').addClass("estil_selected");
			jQuery("#dv_fill_color_icon").css("background-color",estilP.colorGlif);	
			jQuery('.bs-glyphicons li').css('color',estilP.colorGlif);

			if(estilP.colorGlif=="#FFFFFF"){
				jQuery('.bs-glyphicons li').css('background-color','#aaaaaa');	
			}else{
				jQuery('.bs-glyphicons li').css('background-color','#FFFFFF');	
			}			
			
		}else{//Si es marker
			
			estilP.iconFons = icon.className+'-web awesome-marker-icon-'+icon.markerColor;
			estilP.iconGlif = 'fa fa-'+icon.icon;
			estilP.colorGlif = icon.iconColor;
			estilP.fontsize = '14px';
			estilP.divColor = 'transparent';
			estilP.width = '28px';
			estilP.height = '42px';
			
			jQuery("#div_puntM").addClass("estil_selected");
			jQuery("#dv_fill_color_marker").css("background-color", InstamapsUtils.Styles.getColorFromClass(icon.markerColor));
			jQuery('#div_punt_1').removeClass().addClass('awesome-marker-web awesome-marker-icon-'+icon.markerColor);
			
			jQuery(".bs-glyphicons li .fa-"+icon.icon).parent('li').addClass("estil_selected");
			jQuery("#dv_fill_color_icon").css("background-color",estilP.colorGlif);
			jQuery('.bs-glyphicons li').css('color',estilP.colorGlif);
			if(estilP.colorGlif=="#FFFFFF"){
				jQuery('.bs-glyphicons li').css('background-color','#aaaaaa');	
			}else{
				jQuery('.bs-glyphicons li').css('background-color','#FFFFFF');	
			}			
		}
		
		jQuery('#div_punt0').removeClass();
		jQuery('#div_punt0').addClass(estilP.iconFons+" "+estilP.iconGlif);
		jQuery('#div_punt0').css('width',estilP.width);
		jQuery('#div_punt0').css('height',estilP.height);	
		jQuery('#div_punt0').css('font-size',estilP.fontsize);
		jQuery('#div_punt0').css('background-color',estilP.divColor);
		jQuery('#div_punt0').css('color',estilP.colorGlif);
	}
}

function updateFeatureCount(fromBusinessId, toBusinessId){
	
	//Actualitzem comptador de la capa
	if(fromBusinessId){
		var sFromCount = $("#count-"+fromBusinessId).html();
		if (sFromCount!=undefined){
			sFromCount = sFromCount.replace("(", " ");
			sFromCount = sFromCount.replace(")", " ");	
			var fromCount = parseInt(sFromCount.trim());
			fromCount=fromCount-1;
			$("#count-"+fromBusinessId).html(' ('+fromCount+')');
		}
	}

	if(toBusinessId){
		var sToCount = $("#count-"+toBusinessId).html();
		if (sToCount!=undefined){
			sToCount = sToCount.replace("(", " ");
			sToCount = sToCount.replace(")", " ");	
			var toCount = parseInt(sToCount.trim());
			toCount=toCount+1;
			$("#count-"+toBusinessId).html(' ('+toCount+')');		
		}
	}
//	console.debug("Fi updateFeatureCount");
}

function addDrawTooltips() {
	L.drawLocal = {
		draw : {
			handlers : {
				marker : {
					
					tooltip : {
						start : window.lang.translate('Fes clic al mapa per posar un punt')
					}
				},
				polygon : {
					tooltip : {
						start : window.lang.translate('Clica per començar a dibuixar una àrea'),
						cont : window.lang.translate('Clica per continuar dibuixant una àrea'),
						end : window.lang.translate('Clica el primer punt per tancar aquesta àrea')
					}
				},
				polyline : {
					error : '<strong>Error:</strong> àrees no es poden creuar!',
					
					tooltip : {
						start : window.lang.translate('Clica per començar a dibuixar una línia'),
						cont : window.lang.translate('Clica per continuar dibuixant una línia'),
						end : window.lang.translate('Clica el darrer punt per acabar la línia')
					}
				}
			}
		},
		edit : {
			handlers : {
				edit : {
					
					tooltip : {
						text :window.lang.translate("Arrossega el punt o un vèrtex per editar l'objecte")+"<br/>"+window.lang.translate('Fes Ctrl+clic per esborrar un vèrtex')+"<br/>",
						subtext: window.lang.translate('Prem la tecla "Esc" per finalitzar')
					}
				}
			}
		}
	};
	return L.drawLocal;
}

function addHtmlInterficieDraw(){
	var html = ''+
	'<div class="div_auto">'+
	'	<div class="dibuix_punt_wrapper">'+
	'		<div id="div_punt" class="dibuix_punt" data-toggle="tooltip" data-lang-title="Clica per situar un punt" title="Clica per situar un punt">'+
	'		</div>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_punts" class="icon-add taronja" data-toggle="tooltip" data-lang-title="Més estils de punts" title="Més estils de punts"></div>'+
	'	</div>'+
	'	<span class="span_estils" lang="ca">Estils dels punts</span>'+
	'</div>'+
	'<div class="div_auto">'+
	'	<div id="div_linia" class="dibuix_linia" data-toggle="tooltip" data-lang-title="Clica per començar a dibuixar una línia" title="Clica per començar a dibuixar una línia">'+
	'	<canvas id="cv_linia" width="40" height="40"></canvas>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_linies" class="icon-add taronja" data-toggle="tooltip" data-lang-title="Més estils de línia" title="Més estils de línia"></div>'+
	'	</div>'+
	'	<span class="span_estils" lang="ca">Estils de les línies</span>'+
	'</div>'+
	'<div class="div_auto">'+
	'	<div id="div_area" class="dibuix_poligon" data-toggle="tooltip" data-lang-title="Clica per començar a dibuixar una àrea" title="Clica per començar a dibuixar una àrea">'+
	'	<canvas id="cv_pol" width="40" height="40"></canvas>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_arees" class="icon-add taronja" data-toggle="tooltip" data-lang-title="Més estils d\'àrees" title="Més estils d\'àrees"></div>'+
	'	</div>'+
	'	<span class="span_estils" lang="ca">Estils dels polígons</span>'+
	'</div>';
	
	/*
	var html = ''+
	'<div class="div_auto">'+
	'	<div id="div_punt" class="dibuix_punt" data-toggle="tooltip" data-lang-title="Clica per situar un punt" title="Clica per situar un punt">'+
	'      <span class="instaicon-marcador_A"></span>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_punts" class="geostart-palette" data-toggle="tooltip" data-lang-title="Més estils de punts" title="Més estils de punts"></div>'+
	'	</div>'+
	'	<span class="span_estils_dibuix" lang="ca">Estils dels punts</span>'+
	'</div>'+
	'<div class="div_auto">'+
	'	<div id="div_linia" class="dibuix_linia" data-toggle="tooltip" data-lang-title="Clica per començar a dibuixar una línia" title="Clica per començar a dibuixar una línia">'+
	'      <span class="instaicon-linia"></span>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_linies" class="geostart-palette" data-toggle="tooltip" data-lang-title="Més estils de línia" title="Més estils de línia"></div>'+
	'	</div>'+
	'	<span class="span_estils_dibuix" lang="ca">Estils de les línies</span>'+
	'</div>'+
	'<div class="div_auto">'+
	'	<div id="div_area" class="dibuix_poligon" data-toggle="tooltip" data-lang-title="Clica per començar a dibuixar una àrea" title="Clica per començar a dibuixar una àrea">'+
	'      <span class="instaicon-area"></span>'+
	'	</div>'+
	'	<div class="add_costat">'+
	'		<div lang="ca" id="div_mes_arees" class="geostart-palette" data-toggle="tooltip" data-lang-title="Més estils d\'àrees" title="Més estils d\'àrees"></div>'+
	'	</div>'+
	'	<span class="span_estils_dibuix" lang="ca">Estils dels polígons</span>'+
	'</div>';
	*/

	jQuery("#funcio_draw").append(html);
	
	$('#div_punt').tooltip({placement : 'bottom',container : 'body'});
	$('#div_linia').tooltip({placement : 'bottom',container : 'body'});
	$('#div_area').tooltip({placement : 'bottom',container : 'body'});	
	
	$('#div_mes_punts').tooltip({placement : 'right',container : 'body'});
	$('#div_mes_linies').tooltip({placement : 'right',container : 'body'});
	$('#div_mes_arees').tooltip({placement : 'right',container : 'body'});
}

function activarSnapping(capaEdicio){
	if (capaEdicio.getLayers()[0].snapediting==undefined){
		//Activate snapping
		if (capaEdicio.getLayers()[0].properties.tipusFeature != undefined && capaEdicio.getLayers()[0].properties.tipusFeature=="marker"){
			try{
				capaEdicio.getLayers()[0].editing = new L.Handler.MarkerSnap(map, capaEdicio.getLayers()[0],{snapDistance:10});
				capaEdicio.getLayers()[0].snapediting = new L.Handler.MarkerSnap(map, capaEdicio.getLayers()[0],{snapDistance:10});
			}catch(exc){
				
			}
		}
		else{					
			capaEdicio.getLayers()[0].editing = new L.Handler.PolylineSnap(map, capaEdicio.getLayers()[0],{snapDistance:10});
			capaEdicio.getLayers()[0].snapediting = new L.Handler.PolylineSnap(map, capaEdicio.getLayers()[0],{snapDistance:10});
		}
	}
	for(var i = 0;i < guideLayers.length; i++) {
			// Add every already drawn layer to snap list
		capaEdicio.getLayers()[0].snapediting.addGuideLayer(guideLayers[i]);
		// Add the currently drawn layer to the snap list of the already drawn layers
		if ( guideLayers[i].snapediting!=undefined){
			guideLayers[i].snapediting.addGuideLayer(capaEdicio.getLayers()[0]);
			guideLayers[i].snapediting.enable();
			if (guideLayers[i].editing!=undefined) guideLayers[i].editing.disable();
			if (guideLayers[i].dragging!=undefined) guideLayers[i].dragging.enable(); 
		}
		else {
			if (guideLayers[i].properties.tipusFeature != undefined && guideLayers[i].properties.tipusFeature=="marker"){
				try{
					guideLayers[i].snapediting = new L.Handler.MarkerSnap(map, layer,{snapDistance:10});
				}catch(exc){
					
				}
			}
			else{
				guideLayers[i].snapediting = new L.Handler.PolylineSnap(map, capaEdicio.getLayers()[0],{snapDistance:10});
			}
			if (guideLayers[i].snapediting!=undefined) {
				guideLayers[i].snapediting.addGuideLayer(capaEdicio.getLayers()[0]);
				guideLayers[i].snapediting.enable();
			}
			if (guideLayers[i].editing!=undefined)  guideLayers[i].editing.disable();
			if (guideLayers[i].dragging!=undefined) guideLayers[i].dragging.enable(); 
		}
		if (capaEdicio.getLayers()[0].properties.tipusFeature != undefined && capaEdicio.getLayers()[0].properties.tipusFeature=="marker"){
			try{
				if (guideLayers[i].editing!=undefined)  guideLayers[i].editing.disable();
				if (guideLayers[i].dragging!=undefined) guideLayers[i].dragging.enable();
			}catch(exc){
				
			}
		}
	}
	try{
		capaEdicio.getLayers()[0].snapediting.enable();
	}
	catch(exc){
		
	}
	// Add to drawnItems
	drawnItems.addLayer(capaEdicio.getLayers()[0]);
	// Add newly drawn feature to list of snappable features
	guideLayers.push(capaEdicio.getLayers()[0]);
}

function actualitzarComboCapes(){	
	var defer = $.Deferred();
	if(controlCapes){
		$.each( controlCapes._layers, function(i,val) {//refresquem combo de totes les capes del mapa
			var layer2 = val.layer.options;
			html = reFillCmbCapesUsr(layer2.geometryType, layer2.businessId);
			try{
				$.each( val.layer._layers, function(i2,val2) {
					jQuery('#cmbCapesUsr-'+val2._leaflet_id+'-'+layer2.geometryType+'-'+val2.properties.capaLeafletId).html(html);
				});
			}catch(e){			
			} 
		});
		defer.resolve();
	}
	return defer.promise();
}


